// FORMATAÇÃO CNPJ:
// CNPJ alfanumérico (Receita Federal, a partir de 01/08/2026): as 12 primeiras posições aceitam
// letras além de dígitos; os 2 dígitos verificadores finais continuam sempre numéricos.
const cnpjComPontuacao = (cnpj) => {
  let cnpjFormatado;
  try {
    cnpjFormatado = cnpj.replace(
      /^([0-9A-Za-z]{2})([0-9A-Za-z]{3})([0-9A-Za-z]{3})([0-9A-Za-z]{4})(\d{2})/,
      '$1.$2.$3/$4-$5'
    );
  } catch {
    return cnpj;
  }
  return cnpjFormatado;
};
const cnpjSemPontuacao = (value) => {
  return value.replace(/[^0-9A-Za-z]/g, '');
};

const cpfComPontuacao = (cpf) => {
  let cpfFormatado;
  try {
    cpfFormatado = cpf.replace(
      /^(\d{3})(\d{3})(\d{3})(\d{2})/,
      '$1.$2.$3-$4'
    );
  } catch {
    return cpf;
  }
  return cpfFormatado;
};

const cpfSemPontuacao = (value) => {
  return value.replace(/\D/g, '');
};

export default {
  cnpjComPontuacao,
  cnpjSemPontuacao,
  cpfComPontuacao,
  cpfSemPontuacao,
};
